// ///storage constant
///const { host } = window.location
export default {
  STORAGE_URL: "https://storage.oms.innovate10x.com",
  SERVERS_URL:
    "https://ams-servers-list.activitymanagementsolution.com/ams-servers-v2",
  DEV_URL: "dev10-web.oms.innovate10x.com",
  MEDIA_PREFIX: "scanned-media-prefix",
  FIELD_TYPE_TEXT : 1,
  FIELD_TYPE_NUMBER : 2,
  FIELD_TYPE_DATE : 3,
  FIELD_TYPE_SELECT : 4,
  FIELD_TYPE_MULTISELECT : 5,
  FIELD_TYPE_TEXTAREA : 6,
  FIELD_TYPE_CHECKBOX : 7,
  FIELD_TYPE_RADIO : 8,
  FIELD_TYPE_FILE : 9,
  FIELD_TYPE_DATETIME : 10,
};
